import React, { useEffect, useState } from 'react'
import * as routeLink from "../../constants/routeLink";
import { useNavigate } from 'react-router-dom';
import { createChart } from 'lightweight-charts';
import { useSelector } from 'react-redux';
import { bet, domain, getChartData, history, } from '../../services/services';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let chart
let area

const Index = (props) => {
    const [timeChart, setTimeChart] = useState('1m');

    return (
        <div className="main-axis lg:mt-[84px] mx-auto bg-[#5151511A] rounded-[30px] py-7 lg:py-[60px]">
            <div className="w-full lg:min-w-[644px] lg:w-fit mx-auto flex flex-col gap-3 lg:gap-[22px]">
                <div className="w-full flex-v items-center">
                    <h2 className="t-600-18-white lg:t-600-24-white text-center">Invite Friends &amp; Earn
                        Rewards!</h2>
                    <p className="t-500-14-gray text-center">Earn 10% from each referrals trading fees. Start
                        sharing and earning today!</p>
                    <div
                        className="w-full h-[90px] flex-h items-center justify-between px-[14px] lg:px-[34px] rounded-[15px] gradient-primary mt-[22px] lg:mt-[45px]">
                        <div className="flex-1 flex-h justify-between items-center lg:items-start">
                            <div className="flex-v lg:flex-h lg:justify-start lg:items-center lg:gap-1"><span
                                className="t-600-14-black lg:t-600-16-black text-nowrap">Total
                                Referrals</span><span
                                    className="t-800-18-black lg:t-800-32-black text-nowrap">0</span></div><i
                                        className="w-[1px] h-[68px] lg:h-[54px] bg-[#252B33] mx-[14px] lg:mx-[80px]"></i>
                            <div className="flex-v lg:flex-h lg:justify-end lg:items-center lg:gap-1"><span
                                className="flex-h gap-1 t-600-14-black lg:t-600-16-black text-nowrap">Total
                                Earned<img alt="bnb icon" loading="lazy" width="21" height="21"
                                    decoding="async" data-nimg="1"
                                    
                                    src={`${routeLink.domain}/assets/imgs/bnb.png`}
                                    style={{ color: "transparent" }} /></span><span
                                        className="t-800-18-black lg:t-800-32-black text-nowrap">0</span></div>
                        </div><button type="button"
                            className="ant-btn css-sic622 ant-btn-default w-fit !h-[30px] t-600-14-black  !px-[18.5px] !py-1 rounded-[9px] cursor-pointer !bg-white ml-2 lg:ml-[35px] !border-0 active:border-0  hover:!text-black active:!text-black"><span>Claim</span></button>
                    </div>
                    <div
                        className="w-full flex-v justify-center  gap-1 px-[14px] lg:px-[34px] py-3 lg:py-5  rounded-[15px] border border-[#252B33] bg-[#5151511A] mt-[22px]">
                        <span className="t-600-12-white lg:t-600-16-white">Who Invited Me (Please enter
                            inviter's referral code)</span>
                        <div className="w-full flex-v lg:flex-h justify-between lg:items-center gap-2"><input
                            type="text"
                            className="ant-input css-sic622 ant-input-outlined flex-1 !h-[30px] leading-[30px] px-2 lg:px-[26px] rounded-[9px] t-500-14-white !bg-black"
                            value="" /><span
                                className="w-full lg:w-fit t-600-14-black  px-[18.5px] py-1 rounded-[9px] text-center  gradient-primary cursor-not-allowed">save</span>
                        </div>
                    </div>
                    <div
                        className="w-full flex-v  rounded-[15px] border border-[#252B33] bg-[#5151511A] px-[14px] lg:px-[34px] py-5 mt-[22px] gap-3">
                        <div className="w-full flex-v justify-center  gap-1"><span
                            className="t-600-12-white lg:t-600-16-white">My Referal Link</span>
                            <div className="w-full flex-v lg:flex-h justify-between lg:items-center gap-2">
                                <div
                                    className="flex-1 h-[30px] leading-[30px] px-2 lg:px-[26px] rounded-[9px] t-500-12-white lg:t-500-14-white bg-black text-nowrap overflow-hidden text-ellipsis">
                                    https://four.meme?code=XDSY9WN7UZHB</div>
                                <div className="flex flex-row flex-nowrap items-center"><span
                                    className="w-full lg:w-fit t-600-14-black  px-[18.5px] py-1 rounded-[9px] text-center cursor-pointer gradient-primary">Copy</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex-v justify-center  gap-1"><span
                            className="t-600-12-white lg:t-600-16-white">My Referal Code</span>
                            <div className="w-full flex-v lg:flex-h justify-between lg:items-center gap-2">
                                <div
                                    className="flex-1 h-[30px] leading-[30px] px-2 lg:px-[26px] rounded-[9px] t-500-12-white lg:t-500-14-white bg-black text-nowrap">
                                    XDSY9WN7UZHB</div>
                                <div className="flex flex-row flex-nowrap items-center"><span
                                    className="w-full lg:w-fit t-600-14-black  px-[18.5px] py-1 rounded-[9px] text-center cursor-pointer gradient-primary">Copy</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Index;
